import { Stack } from '@mui/material';
import React from 'react';

type DreamJobScreen2ArrowLeftProps = {
    screen: number;
    bgColor: string;
    setScreen: (screen: number) => void;
};
const DreamJobScreen2ArrowLeft = ({
    bgColor,
    screen,
    setScreen
}: DreamJobScreen2ArrowLeftProps) => {
    const current = {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#999',
        cursor: 'pointer'
    };

    const notCurrent = {
        bgcolor: bgColor,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: bgColor,
        cursor: 'pointer'
    };
    return (
        <Stack
            onClick={() => setScreen(1)}
            alignSelf="flex-start"
            p="20px"
            borderRadius="100px"
            sx={screen === 1 ? current : notCurrent}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
                    stroke={screen === 1 ? '#999' : '#fff'}
                    strokeWidth="3"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </Stack>
    );
};

export default DreamJobScreen2ArrowLeft;
